import $ from 'jquery'

module.exports = (options) => {
  $(options.el[0]).on('submit', e => {
    e.preventDefault()
  })
}
